import { decimalPlaces } from './enum';

export function formatPrice(price) {
  return price.toLocaleString('es-CO', {maximumFractionDigits: 2});
}

export function handleChangeIdentification(value) {
  value = value.replace(/\D/g, '');
  value = value.replaceAll('.', '');
  value = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')

  return value;
}

export function writeExtensionOfPrice(price) {
  const length = price.toString().length;
  const place = decimalPlaces.find(item => item.size.indexOf(length) > -1);
  let value;
  const index = place.size.findIndex(item => item === length);

  value = price.toString().substr(0, index + 1);  

  return `$ ${value} ${place.nombre}`;
}
